/**
 * Sort customizations by their display order from product categories
 * @param {Array} customizations - Array of customization objects with option_id
 * @param {Array} productCategories - Array of product category objects with display_order and options
 * @returns {Array} Sorted customizations array
 */
export const sortCustomizations = (customizations, productCategories) => {
  if (!customizations || !productCategories || customizations.length === 0) {
    return customizations || [];
  }

  return [...customizations].sort((a, b) => {
    // Find the categories for each customization
    const catA = productCategories.find(cat => 
      cat.options?.some(opt => opt.option_id === a.option_id)
    );
    const catB = productCategories.find(cat => 
      cat.options?.some(opt => opt.option_id === b.option_id)
    );
    
    // Sort by category display_order first
    const catOrderA = catA?.display_order ?? 999;
    const catOrderB = catB?.display_order ?? 999;
    
    if (catOrderA !== catOrderB) {
      return catOrderA - catOrderB;
    }
    
    // Within same category, sort by option display_order
    const optA = catA?.options?.find(opt => opt.option_id === a.option_id);
    const optB = catB?.options?.find(opt => opt.option_id === b.option_id);
    
    const optOrderA = optA?.display_order ?? 999;
    const optOrderB = optB?.display_order ?? 999;
    
    return optOrderA - optOrderB;
  });
};

/**
 * Sort product categories by their display order
 * @param {Array} categories - Array of category objects with display_order
 * @returns {Array} Sorted categories array
 */
export const sortCategories = (categories) => {
  if (!categories || categories.length === 0) {
    return categories || [];
  }

  return [...categories].sort((a, b) => {
    const orderA = a.display_order ?? 999;
    const orderB = b.display_order ?? 999;
    return orderA - orderB;
  });
};

/**
 * Sort options within a category by their display order
 * @param {Array} options - Array of option objects with display_order
 * @returns {Array} Sorted options array
 */
export const sortOptions = (options) => {
  if (!options || options.length === 0) {
    return options || [];
  }

  return [...options].sort((a, b) => {
    const orderA = a.display_order ?? 999;
    const orderB = b.display_order ?? 999;
    return orderA - orderB;
  });
};
